export { default } from './Shop';